import { AnyExtension, Command, Extension } from '@tiptap/core'

import addWidgetPlugin from './add-widget-plugin'
import { ImageNode, ImageNodeOptions } from './image-node'
import { mediaDropPlugin } from './media-drop-plugin'
import { VideoNode, VideoNodeOptions } from './video-node'

import insertMedia, { MediaUploadOptions } from '~lib/editor/extensions/media/insertMedia'
import { PlaceholderOptions } from '~lib/editor/extensions/placeholder'
import { isImage, isVideo } from '~lib/utils/files'

declare module '@tiptap/core' {
  interface Commands {
    mediaExtension: {
      insertImages: (files: File[], options?: Partial<MediaUploadOptions>) => Command
      insertVideos: (files: File[], options?: Partial<MediaUploadOptions>) => Command
    }
  }
}

type MediaExtensionsOptions = {
  upload?: MediaUploadOptions
  image?: ImageNodeOptions
  video?: VideoNodeOptions
  enabled?: boolean
}

export default function mediaExtensions(options: MediaExtensionsOptions): AnyExtension[] {
  return !options.enabled
    ? ([] as AnyExtension[])
    : ([
        Extension.create<PlaceholderOptions>({
          name: 'mediaExtension',

          addCommands() {
            return {
              insertImages:
                (files: File[], uploadOpt?: Partial<MediaUploadOptions>) =>
                ({ view, state }) => {
                  const mergedOpt = { ...options.upload, ...uploadOpt }
                  const images = files.filter((file) => isImage(file))
                  if (images.length === 0) return false

                  // const position = state.selection.$cursor ? state.selection.$cursor.pos : state.selection.$to.pos
                  const position = state.selection.$to.pos
                  insertMedia(view, position, images, mergedOpt)
                  return true
                },
              insertVideos:
                (files: File[], uploadOpt?: Partial<MediaUploadOptions>) =>
                ({ view, state }) => {
                  const mergedOpt = { ...options.upload, ...uploadOpt }
                  const videos = files.filter((file) => isVideo(file))
                  if (videos.length === 0) return false

                  // const position = state.selection.$cursor ? state.selection.$cursor.pos : state.selection.$to.pos
                  const position = state.selection.$to.pos
                  insertMedia(view, position, videos, mergedOpt)
                  return true
                },
            }
          },
          addProseMirrorPlugins() {
            return [addWidgetPlugin, mediaDropPlugin(options.upload)]
          },
        }),
        ImageNode.configure(options.image),
        VideoNode.configure(options.video),
      ] as AnyExtension[])
}
